import { useState } from "react"

import { useBreakpoints } from "shared/lib/breakpoints/useBreakpoints"
import {
  HorizontalBreakpoint,
  getValueForBreakpoint
} from "shared/types/Breakpoints"
import { Direction } from "shared/types/Direction"

import { useEvent } from "./useEvent"
import { UseRovingTabIndexArgs, useRovingTabIndex } from "./useRovingTabIndex"

interface UseRovingTabIndexGridProps
  extends Omit<UseRovingTabIndexArgs<Direction.GRID>, "columnCount"> {
  columnsByBreakpoint?: Partial<Record<HorizontalBreakpoint, number>>
}

export function useRovingTabIndexGrid<
  ElementHTMLElementType extends HTMLElement = HTMLDivElement,
  ContainerHTMLElementType extends HTMLElement = HTMLDivElement
>({ elementCount, columnsByBreakpoint, ...rest }: UseRovingTabIndexGridProps) {
  const [columnCount, setColumnCount] = useState(1)
  const handleUpdateColumnCount = useEvent(
    (bps: Record<HorizontalBreakpoint, boolean>) => {
      if (columnsByBreakpoint) {
        const currentColumnCount = getValueForBreakpoint(
          bps,
          columnsByBreakpoint
        )
        setColumnCount(currentColumnCount || 1)
      }
    }
  )

  const rovingTabIndex = useRovingTabIndex<
    ElementHTMLElementType,
    ContainerHTMLElementType
  >({
    elementCount,
    direction: Direction.GRID,
    columnCount,
    ...rest
  })

  useBreakpoints(rovingTabIndex.container, {
    onChange: handleUpdateColumnCount
  })

  return {
    ...rovingTabIndex,
    columnCount,
    rowCount: Math.ceil(elementCount / columnCount)
  }
}
